import { render } from "./P5Sketch.vue?vue&type=template&id=218a46e5&scoped=true"
import script from "./P5Sketch.vue?vue&type=script&lang=js"
export * from "./P5Sketch.vue?vue&type=script&lang=js"

import "./P5Sketch.vue?vue&type=style&index=0&id=218a46e5&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218a46e5"]])

export default __exports__